<template>
    <ProductsScrollCarousel
        :products="products"
        :card="cardComponent"
        :preview-only="previewOnly"
        :is-desktop="isDesktop"
        :open-in-new-tab="openInNewTab"
    />
</template>

<script>
import {
    DEFAULT_PRODUCT_CAROUSEL_VARIANT,
    productCardComponents
} from "@/components/catalog/product-sliders";
import ProductsScrollCarousel from "@/components/catalog/product-sliders/ProductsScrollCarousel.vue";

export default {
    name: "ProductsCarouselSegment",
    components: { ProductsScrollCarousel },
    props: {
        products: { type: Array, required: true },
        variant: { type: String, default: DEFAULT_PRODUCT_CAROUSEL_VARIANT },
        openInNewTab: { type: Boolean, default: false },
        previewOnly: { type: Boolean, default: false },
        isDesktop: { type: Boolean, default: true }
    },
    computed: {
        cardComponent() {
            return (
                productCardComponents[this.variant] ||
                productCardComponents[DEFAULT_PRODUCT_CAROUSEL_VARIANT]
            );
        }
    }
};
</script>
